export enum ConfigurationKeysEnum {
    PRODUCTION_ORDER_PROCESSES_DETAIL_OPEN_IN_NEW_TAB = 'productionOrderProcessesDetail.process.openInNewTab',
    PRODUCTION_ORDER_PROCESSES_BATCH_FORMAT = 'productionOrderProcesses.batches.batchFormat',
    PRODUCTION_ORDERS_KEEP_UNTIL = 'productionOrders.orders.keepUntil',
    QUALITY_CONTROL_ACTIVATED = 'qualityControl.activated',
    QUALITY_CONTROL_DELAY_IN_SECONDS = 'qualityControl.delayInSeconds',
    QUALITY_CONTROL_DELAY_IN_QUANTITY_PRODUCED = 'qualityControl.delayInQuantityProduced',
    PRODUCTION_ORDERS_PROCESSES_DETAIL_SENSORS = 'productionOrdersProcessesDetail.sensors',
    RABBIT_VHOST = 'rabbit.vhost',
    PRODUCTION_ORDERS_MULTIPLE_PROCESSES_RUNNING = 'productionOrders.multipleProcessesRunning',
    CONNECTOR_API_URL = 'connector.api.url',
    CONNECTOR_API_CONTROLLER = 'connector.api.controller',
    MIGRATOR_SEND_DATA_TO_CUSTOMER = 'migrator.send.data.to.customer',
    USERS_CREATION_LIMIT = 'users.creation.limit',
    SCREENS_CREATION_LIMIT = 'screens.creation.limit',
    LOGIN_SEND_CODE = 'login.sendCode',
    ORDER_ID_COLUMN_VALUE = 'order.idColumnValue',
    PAUSE_VALIDATION_TIME = 'pause.validation.time',
    MIGRATOR_SEND_DATA_TO_CUSTOMER_RAW_MATERIALS = 'migrator.send.data.to.customer.rawMaterials',
    MIGRATOR_SEND_DATA_TO_CUSTOMER_FINAL_PRODUCTS_QUANTITY = 'migrator.send.data.to.customer.finalProductsQuantity',
    SENSOR_SPEED_THRESHOLD_PERCENTAGE = 'sensor.speed.threshold.percentage',
    PRODUCTION_ORDER_FINAL_QUANTITY = 'productionOrder.final.quantity',
    PRODUCTION_ORDERS_GENERATE_NEW_LABEL_BUTTON_ENABLED = 'productionOrders.generateNewLabelButton.enabled',
    RAW_MATERIALS_CHANGE_ARTICLE_ENABLED = 'rawMaterials.changeArticle.enabled',
    PRODUCTION_ORDERS_REPRINT_LABEL_PALLET_LOT_SOURCE = 'productionOrders.reprintLabel.pallet.lotSource'
}
